var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FForm',{attrs:{"route":"operators","title":"Operator","schema":[
    {
      component: 'FInput',
      key: 'name',
      label: 'Name'
    },
    {
      component: 'FEditor',
      key: 'contact',
      label: 'Contact information'
    }
  ]},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})}
var staticRenderFns = []

export { render, staticRenderFns }